import React, { useMemo, useState } from 'react';
import './ScopesPage.css';
import { ScopeDto } from '../../types';
import { callGovernanceApi } from '@/utils/ProtectedApiCall';
import { useSwitchContext } from '@/components/button/SwitchButtonContext';
import ScopesTable from '@/components/table/scopes/ScopesTable';

export const ScopesContent: React.FC = () => {
  const [scopesData, setScopesData] = useState<ScopeDto[] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const { selectedTenant } = useSwitchContext();

  useMemo(() => {
    setLoading(true);
    callGovernanceApi(`/api/scopes?tenant=${selectedTenant}`, 'GET')
      .then((response) => setScopesData(response))
      .catch((e) => {
        console.log(e);
      })
      .finally(() => setLoading(false));
  }, [selectedTenant]);

  return (
    <div>
      {loading ? (
        <div>Loading...</div>
      ) : scopesData ? (
        <ScopesTable scopes={scopesData} />
      ) : (
        <div>No data available</div>
      )}
    </div>
  );
};
const ScopesPage: React.FC = () => {
  return <ScopesContent />;
};

export default ScopesPage;
